export default function Die(props) {
  return (
    <p
      className="die"
      style={
        props.isHeld
          ? { backgroundColor: "#59E391" }
          : { backgroundColor: "#fff" }
      }
      onClick={() => props.holdDice(props.id)}
    >
      {props.value}
    </p>
  );
}
